export default __webpack_public_path__ + "static/media/videocase1.a11483d9.png";